const WHATSAPP_URL = 'https://wa.me/message/3YKLB2YGV573O1';
const EMAIL_URL =
  'mailto:mhradic@gmail.com?subject=Website%20Project&body=Hi%2C%20I%27m%20interested%20in%20getting%20a%20website.';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-24 overflow-hidden">

      {/* Radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 50% 10%, rgba(255,255,255,0.04) 0%, transparent 70%)',
        }}
      />

      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto w-full">
        {/* Label */}
        <span
          className="animate-fade-up delay-100 text-xs font-display font-medium tracking-[0.25em] uppercase text-white/30 mb-10 md:mb-12"
        >
          Web Design Studio
        </span>

        {/* Headline */}
        <h1
          className="animate-fade-up delay-200 font-display font-bold text-white leading-[1.06] tracking-tight mb-6 md:mb-8"
          style={{ fontSize: 'clamp(2.6rem, 6vw + 1rem, 5.5rem)' }}
        >
          We build websites that
          <br className="hidden sm:block" />
          {' '}help you get clients.
        </h1>

        {/* Subheadline */}
        <p
          className="animate-fade-up delay-300 text-base sm:text-lg md:text-xl text-white/40 max-w-xl leading-relaxed mb-12 md:mb-14"
          style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
        >
          Fast, modern, and conversion-focused websites for
          businesses and creators.
        </p>

        {/* Buttons */}
        <div className="animate-fade-up delay-400 flex flex-col sm:flex-row items-center gap-3 sm:gap-4 w-full sm:w-auto">
          <a
            href={EMAIL_URL}
            className="whitespace-nowrap w-full sm:w-auto flex items-center justify-center gap-2 bg-white text-[#090909] font-display font-semibold text-sm tracking-wide px-8 py-4 rounded-full hover:bg-white/90 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-send-plane-line text-base" />
            Send a Message
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap w-full sm:w-auto flex items-center justify-center gap-2 border text-white font-display font-semibold text-sm tracking-wide px-8 py-4 rounded-full hover:border-white/60 hover:bg-white/5 transition-all duration-200 cursor-pointer"
            style={{ borderColor: 'rgba(255,255,255,0.2)' }}
          >
            <i className="ri-whatsapp-line text-base" />
            Chat on WhatsApp
          </a>
        </div>

        {/* Trust line */}
        <p
          className="animate-fade-up delay-500 mt-8 text-xs text-white/20 tracking-wide"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Trusted by small businesses and personal brands.
        </p>
      </div>

      {/* Bottom scroll hint */}
      <div className="animate-fade-in delay-700 absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div
          className="w-px h-10 opacity-10"
          style={{ background: 'linear-gradient(to bottom, transparent, white)' }}
        />
      </div>
    </section>
  );
}

export { WHATSAPP_URL, EMAIL_URL };
